import { axiosHelper, POST_METHOD, GET_METHOD } from './helper'
import { ConfirmEmailPayload, RequestResetPasswordPayload, ResetPasswordPayload, RequestDeleteAccount } from './type'

export function requestResetPassword(payload: RequestResetPasswordPayload) {
  let url = '/user/request-reset-password'
  if (payload.channel) {
    url = `${url}?channel=${payload.channel}`
  }

  return axiosHelper(POST_METHOD, url, payload)
}

export function confirmEmail(payload: ConfirmEmailPayload) {
  return axiosHelper(POST_METHOD, '/user/confirm-email', payload)
}

export function resetPassword(payload: ResetPasswordPayload) {
  return axiosHelper(POST_METHOD, '/user/reset-password', payload)
}

export function resetPasswordLanding(payload: ResetPasswordPayload) {
  return axiosHelper(POST_METHOD, '/user/reset-password-landing', payload)
}

export function userInfo() {
  return axiosHelper(GET_METHOD, '/user/info?account=true', null)
}

export function requestDeleteAccount(payload: RequestDeleteAccount) {
  return axiosHelper(POST_METHOD, '/user/delete-account', payload)
}
